import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './statusChip.intl.json';

export const useStatusChipIntl = () => useIntlModule(messages);
